import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateCampaignEmailDetailsRequest extends BaseUpdateRequest {
    emailTemplateId: string;
    emailFromName: string;
    emailFromAddress: string;
    emailSubject: string;
    emailMergeField1: string;
    emailMergeField2: string;
    emailMergeField3: string;
    emailMergeField4: string;
    emailMergeField5: string;
    isTest = false;
    testEmailAddresses = '';
}